import React from 'react';
import Button from '@mui/material/Button';
import { Formik, Form } from 'formik';
import axios from 'axios';
import LoginIcon from '@mui/icons-material/Login';
import * as yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import {  toast } from 'react-toastify';
import image from './loginimg.png';
import config from '../Config/Config';

const LoginSchema = yup.object().shape({
    email: yup.string()
        .email('Invalid email')
        .required('Email cannot be blank'),
    password: yup.string()
        .required('Password is required')
});


export default function Login() {
    let navigate = useNavigate();
    return (
        <div className='container'>
            <div style={{justifyContent:"space-between"}} className="row d-flex">
                <div style={{ marginTop: "200px" }} className="col-md-4">
                    <div className='d-flex'>
                        <div onClick={() => navigate('/register')} style={{ backgroundColor: "purple" }} className='text-center py-2 text-light rounded w-50 mx-1'><h3>SIGN UP</h3></div>
                        <div onClick={() => navigate('/login')} style={{ backgroundColor: "purple" }} className='text-center py-2 text-light rounded w-50 mx-1'><h3>SIGN IN</h3></div>
                    </div>
                    <Formik
                        initialValues={{
                            email: '',
                            password: '',

                        }}
                        validationSchema={LoginSchema}
                        onSubmit={async (values) => {
                            try {
                                const { data } = await axios.post(config.apiUrllogin, values);
                                console.log(data)
                                localStorage.setItem("token", data.token);
                                toast('Logged-in successfully', {
                                    position: "top-center",
                                    autoClose: 2000,
                                    type: "success",
                                    theme: "colored",
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    })
                                navigate('/home');
                            }
                            catch{
                                toast('Incorrect Credentials', {
                                    position: "top-center",
                                    autoClose: 2000,
                                    type: "error",
                                    theme: "colored",
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    })

                            }
                        }}
                    >
                        {({ errors, touched, handleChange, handleBlur }) => (
                            <Form className='form'>
                                <div className='my-2'>
                                    <input id='email' name='email' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Email' />
                                    {errors.email && touched.email ? <span><div class="alert alert-danger mt-1" role="alert">{errors.email}

                                    </div></span> : null}
                                </div>
                                <div className='my-2'>
                                    <input id='password' name='password' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Password' />
                                    {errors.password && touched.password ? <span><div class="alert alert-danger mt-1" role="alert">{errors.password}

                                    </div></span> : null}
                                </div>
                                <div className='text-muted'><p>New here? <Link to={'/register'}>register</Link></p></div>
                                <div className="my-4 text-center">
                                    <Button type='submit' size="large" color="secondary" variant="contained" endIcon={<LoginIcon />}>
                                        Login
                                    </Button>
                                </div>
                            </Form>
                        )}

                    </Formik>
                    
                </div>
                <div style={{ marginTop: "150px" }} className='col-md-4'>
                    <img style={{width: '40vh'}} src={image}/>

                </div>
            </div>

        </div>
    )
}
